/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportPoliciesMutationVariables = Types.Exact<{
  object: Types.ImportPoliciesInput;
}>;

export type ImportPoliciesMutation = { __typename?: 'mutation_root'; import_policies: string };

export const ImportPoliciesDocument = `
    mutation ImportPolicies($object: ImportPoliciesInput!) {
  import_policies(object: $object)
}
    ` as string & TypedDocumentNode<ImportPoliciesMutation, ImportPoliciesMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportPolicies: build.mutation<ImportPoliciesMutation, ImportPoliciesMutationVariables>({
      query: (variables) => ({ document: ImportPoliciesDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportPoliciesMutation } = injectedRtkApi;
